export const GUEST_USER = 'guest';
export const GUARDIAN_USER = 'guardian';
export const EDUCATOR_USER = 'educator';

type GUEST_USER_TYPE = 'guest';
type GUARDIAN_USER_TYPE = 'guardian';
type EDUCATOR_USER_TYPE = 'educator';

export type USER_ROLE = GUARDIAN_USER_TYPE | GUEST_USER_TYPE | EDUCATOR_USER_TYPE;

export interface RoleModel {
  id: GUEST_USER_TYPE | GUARDIAN_USER_TYPE | EDUCATOR_USER_TYPE,
  type: string,
}
